import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '5',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'List names',
    colSize: '27',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'name',
  },
  {
    title: 'No. of items',
    colSize: '4',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'count',
    align: 'right',
  },
];
